var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3ButtonView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 29a7 7 0 1114 0 7 7 0 01-14 0zm7 11a7 7 0 100 14 7 7 0 000-14zM38 22a7 7 0 100 14 7 7 0 000-14zm0 18a7 7 0 100 14 7 7 0 000-14zM20 22a7 7 0 100 14 7 7 0 000-14zm0 18a7 7 0 100 14 7 7 0 000-14z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Button_view.1d443d5f.svg";
export { SvgJ3ButtonView as ReactComponent };